import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { configuration } from 'src/environments/environment';

@Component({
  selector: 'app-intstaff-chat',
  templateUrl: './intstaff-chat.component.html',
  styleUrls: ['./intstaff-chat.component.css']
})
export class IntstaffChatComponent implements OnInit {

  constructor(    public sanitizer: DomSanitizer,) { }
  ChatUrl:any;
  ngOnInit() {

// alert(sessionStorage.getItem("userId"))
   this.ChatUrl = this.sanitizer.bypassSecurityTrustResourceUrl('http://localhost:4200/?USID='+sessionStorage.getItem("userId") );
  }

}
